import React from "react";

import { Props } from "./types";

function ProjectIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 51.243 51.251">
      <g transform="translate(-766.507 75.624)">
        <path
          d="M43.684,11.981H16.38a4.7,4.7,0,0,0-4.694,4.694V35.687a4.69,4.69,0,0,0,4.694,4.682H32a1.346,1.346,0,0,1,.936.394L40.7,47.921c.431.419,1.146.246,1.146-.357V41.33c0-.739.468-.973,1.207-.973h.123c2.587,0,5.187-2.082,5.187-4.682v-19A4.675,4.675,0,0,0,43.684,11.981Z"
          transform="translate(769.384 -72.524)"
          fill="#fff"
        />
        <path
          d="M18.949,15.437H40.806V7.392A4.017,4.017,0,0,0,36.79,3.375H7.392A4.017,4.017,0,0,0,3.375,7.392V27.746a4.017,4.017,0,0,0,4.017,4.017H14.92V19.454A4.036,4.036,0,0,1,18.949,15.437Z"
          transform="translate(763.132 -78.999)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export { ProjectIcon };
